import { ChevronDown, Wallet } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useRetailerSession } from "@/components/feature/retailer/RetailerSessionContext";
import { formatINR } from "../data";

export default function WalletBadge() {
  const navigate = useNavigate();
  const { wallet, loading } = useRetailerSession();

  const available = wallet?.availableBalance ?? 0;
  const status = wallet?.status ?? "HEALTHY";

  const tone =
    status === "BLOCKED"
      ? "bg-danger-bg text-danger"
      : status === "LOW"
        ? "bg-warning-bg text-warning"
        : "bg-primary-50 text-primary-500";

  return (
    <button
      type="button"
      onClick={() => navigate("/retailer/wallet")}
      className={`hidden h-9 items-center gap-1.5 rounded-full px-3.5 md:inline-flex cursor-pointer ${tone}`}
      aria-label="Wallet balance"
      title="Open wallet"
    >
      <span className="flex h-4 w-4 items-center justify-center">
        <Wallet className="h-4 w-4" />
      </span>
      <span className="text-[13px] font-semibold">{loading && !wallet ? "—" : formatINR(available)}</span>
      <span className="flex h-4 w-4 items-center justify-center">
        <ChevronDown className="h-4 w-4" />
      </span>
    </button>
  );
}
